<template>
  <el-dialog v-model="dialogStatus" :close-on-click-modal="false" @close="close" :title="dialogTitle" :width="width"
    append-to-body>
    <el-form ref="form" :model="form" :rules="rules" label-width="90px">
      <el-form-item label="CPU架构" prop="cpuModel">
        <el-select v-model="form.cpuModel" clearable placeholder="请输入DSP简称" >
          <el-option label="32-Bit" value="32-Bit"></el-option>
          <el-option label="64-Bit" value="64-Bit"></el-option>
        </el-select>
      </el-form-item>

      <div style="margin-top: 20px;margin-left: 10px;">
        <div>
          <el-radio v-model="form.oppoChannel" :label="0" @change="onChange(0)" style="display: block;">
            暂不送审
          </el-radio>
        </div>

        <div style="margin: 15px 0;color:#02aff4">空闲中渠道id(可选)</div>
        <div v-if="oppoChannelIdList.free !== ''">
          <el-radio v-for="(item, index) in oppoChannelIdList.free" :key="index" style="display: block;"
            v-model="form.oppoChannel" :label="item" @change="onChange(1)"></el-radio>
        </div>

        <div style="margin: 15px 0;color:#02aff4">占用中渠道id(可选)</div>
        <div>
          <el-table v-if="oppoChannelIdList.optional !== ''" :data="oppoChannelIdList.optional" style="width: 100%">
            <el-table-column v-for="(index, item) in columns" :prop="index.field" :label="index.title">
              <template v-slot="scope">
                <el-radio v-if="index.field === 'oppoChannel'" style="display: block;" v-model="form.oppoChannel"
                  :label=Number(scope.row[index.field]) @change="onChange(2)">
                </el-radio>
                <span v-else>{{ scope.row[index.field] }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div style="margin: 15px 0;color:#02aff4">占用中渠道id(不可选)</div>
        <div>
          <el-table v-if="oppoChannelIdList.disable !== ''" :data="oppoChannelIdList.disable" style="width: 100%">
            <el-table-column v-for="(index, item) in columns" :prop="index.field" :label=index.title>
              <template v-slot="scope">
                <span>{{ scope.row[index.field] }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

    </el-form>
    <div style="text-align: right;">
      <el-button @click="close" >取消</el-button>
      <el-button @click="submit" type="primary"  :loading="submitLoading">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { fetchDistOppoAppConfig, updateDistOppoAppConfig } from '@/api/manage/dsp/adAppBag'

const form = {
  dspName: undefined,
  apkId: undefined,
  channelType: undefined,
  cpuModel: undefined,
  oppoChannel: undefined
}
export default {
  props: {
    title: String,
    width: {
      type: Number,
      default: 600
    },
    data: Object,
  },
  emits: ['submit'],
  inject: ['init'],
  data() {
    return {
      dialogStatus: false,
      submitLoading: false,
      form: Object.assign({}, form),
      rules: {
        // cpuModel: [{ required: true, message: '请选择CPU架构', trigger: 'blur' }],
      },
      oppoChannelIdList: [],
      columns: [
        { field: 'oppoChannel', title: '渠道id' },
        { field: 'dspName', title: 'DSP名称' },
        { field: 'apkBundle', title: '应用包名' },
        { field: 'verCode', title: '版本号' },
      ],
      oppoChannel: "",
      channelType: ""
    }
  },
  computed: {
    dialogTitle() {
      return (this.title ? this.title : '') + (this.form.dspId ? '编辑' : '新增')
    }
  },
  created() { },
  methods: {
    _fetchDistOppoAppConfig(apkId) {
      fetchDistOppoAppConfig({ apkId }).then(res => {
        if (res.code === 200) {
          this.oppoChannelIdList = res.data
        }
      })
    },
    show(data) {
      this.dialogStatus = true
      if (data) {
        this.form = Object.assign({}, data)
        this.oppoChannel = data.oppoChannel
        this._fetchDistOppoAppConfig(this.form.apkId)
      }
    },
    close() {
      this.dialogStatus = false
      this.reset()
    },
    submit() {
      if (this.form.oppoChannel && this.form.oppoChannel !== 0) {
        this.form.oppoChannel = this.form.oppoChannel
      } else {
        this.form.oppoChannel = this.oppoChannel
      }
      this.$refs.form.validate(valid => {
        if (valid) {
          this.updateDistOppoAppConfig({
            apkId: this.form.apkId,
            channelType: this.form.channelType,
            cpuModel: this.form.cpuModel,
            oppoChannel: this.form.oppoChannel
          })
        }
      })
    },
    updateDistOppoAppConfig(data) {
      // this.submitLoading = true
      updateDistOppoAppConfig(data).then(res => {
        if (res.code === 200) {
          this.$message.success('配置成功')
          this.close()
          this.init()
          // this.submitLoading = false
        }
      })
    },
    reset() {
      this.form = Object.assign({}, form)
      this.$refs.form.resetFields()
    },
    onChange(channelType) {
      this.form.channelType = channelType
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 15px;
}
</style>
